import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { environment } from 'src/environment';
import * as $ from 'jquery';
import { ModelPaymentComponent } from '../model-payment/model-payment.component';
import { SettingsService, StorageService } from 'src/app/core/services';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { CommonModule, NgIf } from '@angular/common';
@Component({
  selector: 'app-activate-user',
  templateUrl: './activate-user.component.html',
  styleUrls: ['./activate-user.component.scss'],
  standalone: true,
  imports: [NgIf, ModelPaymentComponent, CommonModule]
})
export class ActivateUserComponent implements OnInit {
  @ViewChild('ModelPayment', { static: false }) ModelPaymentComponent: ModelPaymentComponent;
  uId;
  plansLength;
  restrictedUser;
  showPaymentPopup = false;
  hidePlans = true;
  profilesEnabled = false;
  @Input() page;

  skinName = environment.skinName;
  constructor(public configService: ConfigurationService, public planService: PlanService, private storageService: StorageService, private subscriptionService: SubscriptionService,
    private settingsService: SettingsService, private cd: ChangeDetectorRef) {
    this.restrictedUser = environment.isEzProxy || (this.storageService.getLocalStore('hoopla_user') == '1') || (this.storageService.getLocalStore('sso_or_ftp') == '1') ? true : false;
  }

  ngOnInit(): void {
    this.uId = this.storageService.getLocalStore('u_id');
    this.plansLength = this.planService.plansLength;
    this.profilesEnabled = this.settingsService.maxUserProfiles > 0 ? true : false;
  }

  openPaymentPopUp(modalId){
    if (this.plansLength === 1) {
      this.subscriptionService.userPlan().subscribe((data) => {
        if (data) {
          const plan = data.plans[0]; 
          if (plan.type_of_plan === 'alliance_plan') {
            window.open(plan?.redirection_url, '_blank');
            return;
          } else {
            this.showPaymentPopup = true;
            this.cd.detectChanges();
            $(modalId).addClass('uk-open').show();
            this.clearSelectedPaymentOptions();
            return;
          }
        }
      });
    } else {
      this.showPaymentPopup = true;
      this.cd.detectChanges();
      $(modalId).addClass('uk-open').show();
      this.clearSelectedPaymentOptions();
    }
  }

  onPaymentPopupClose() {
    this.showPaymentPopup = false;
    if ((this.ModelPaymentComponent && this.ModelPaymentComponent?.step === 4)) window.location.reload();
  }

  clearSelectedPaymentOptions() {
    this.ModelPaymentComponent.ngOnInit();
  }

  showPlan(){
    this.hidePlans = false;
  }
}
